<template>
<div class="page">
    <!-- tab分类 -->
    <van-tabs v-model="active" swipe-threshold="6" @click="changeTab">
		<van-tab title="待审核" :name="0"></van-tab>
        <van-tab title="已发布" :name="1"></van-tab>
    </van-tabs>
    <!-- 列表 -->
    <div class="page_piaoliu">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="getData">
			<div class="list">
				<div class="item" v-for="item in dataList" :key="item.id">
					<van-image :src="imageUrl+item.image" fit="cover" :show-error="false" :show-loading="false" class="tu" @click="goDetail(item)" />
					<div class="title slh_s" @click="goDetail(item)">{{ item.title }}</div>
					<div class="bottom">
						<div class="user" @click="goDetail(item)">
							<van-image :src="item.user_thumb ? ($publicData.withHttpStart(item.user_thumb) ? item.user_thumb : imageUrl+item.user_thumb) : $publicData.defaultTouxiang " fit="cover" :show-error="false" :show-loading="false" class="thumb" />
							<div class="name">{{ item.user_nickname ? item.user_nickname : '' }}</div>
						</div>
						<div class="like" v-if="item.status == 1" @click="likeFun(item)">
							<img :src=" item.is_like ? publicPath+'statics/images/icon_liked_red.png' : publicPath+'statics/images/icon_like.png'" alt="" class="icon">
							<span :class="item.is_like ? 'nums liked' : 'nums'">{{ item.like_nums }}</span>
						</div>
						<div class="user" v-if="item.status == 0"><span class="name">{{item.timeAgo}}</span></div>
					</div>
				</div>
				<!-- <div class="item">
					<van-image :src="publicPath+'statics/images/temp/yuekan_3.png'" fit="cover" :show-error="false" :show-loading="false" class="tu" @click="goDetail" />
					<div class="title slh_s" @click="goDetail">始终秉承安溪百年古法制茶技艺精髓，坚持只做传统正韵中国茶。</div>
					<div class="bottom">
						<div class="user" @click="goDetail">
							<van-image :src="publicPath+'statics/images/temp/fenleitu.png'" fit="cover" :show-error="false" :show-loading="false" class="thumb" />
							<div class="name">若谷星辰</div>
						</div>
						<div class="like">
							<img :src="publicPath+'statics/images/icon_like.png'" alt="" class="icon">
							<span class="nums">234</span>
						</div>
					</div>
				</div> -->
			</div>
		</van-list>
    </div>

</div>
</template>

<script>
import router from '../../../../.././router'
import {
    LOGOUT,
    LOGIN
} from '../../../../.././vuex/mutation_types'
import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: '',
			active: 0,
			loading: true,
			finished: false,
			dataList: [],
			pages: {
                page: 1,
                size: 10
            },
			goNext: false
        }
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    'naviTitle': '书写记忆让爱漂流',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                (data) => {
                    if (data.code == 200) {
						this.token = data.result.token;
						this.getData()
                    } else {
                        this.token = "";
                    }
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback('');
                }
            );
        } else {
			this.token = this.$store.getters.token;
			// this.getData()

        }
		
    },
    mounted: function () {
		
    },
	activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.token = this.$store.getters.token
			this.getData()
		}
	},
    methods: {
		// 获取列表
        getData() {
			if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var params = {
                token: this.token,
                page: this.pages.page,
				size: this.pages.size,
				status: this.active, // 0 未发布,1 已发布 
				type: 1 // 0 所以列表 1我的列表
            }
            this.$api.history.lovedriftList(params).then(res => {
                if (res.code == 200) {
					var list = res.result.list
					if(list.length != 0){
						for(var i in list){
							if(list[i].thumb){
								var images = list[i].thumb
								list[i].image = images.split(',')[0]
							}
							// 计算时间差
							if(list[i].created_at){
								var time = list[i].created_at
								var dateTimeStamp = this.getTimes(time)
								list[i].timeAgo = this.timeago(dateTimeStamp)
							}
							this.dataList.push(list[i])
						}
						this.loading = false
						this.pages.page++
					}else {
						this.finished = true
					}
				}else{
					this.finished = true
				}
            })
		},
		// 切换tab
		changeTab(){
			this.dataList = []
			this.pages.page = 1
			this.getData()
		},
        // 漂流详情
        goDetail(item) {
			this.goNext = true
            this.$router.push({
				path: '/adrift/detail',
				query: {
					drift_id: item.id,
					status: item.status,
					is_user: 1 // 1 是 0 否, 用户是否可操作
				}
            })
		},
		// 点赞
		likeFun(item){
			var is_like = item.is_like
			var params = {
				token: this.token,
				drift_id: item.id
			}
			this.$api.history.lovedriftLike(params).then(res=>{
				if(res.code == 200) {
					for(var i in this.dataList){
						if(this.dataList[i].id == item.id){
							if(is_like == 0){
								this.$toast('点赞成功')
								this.dataList[i].is_like = 1
								this.dataList[i].like_nums ++;
							}else{
								this.$toast('取消点赞')
								this.dataList[i].is_like = 0
								this.dataList[i].like_nums --;
							}
						}
					}
				}
			})
		},
		// 时间差
		timeago(dateTimeStamp){
			var minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
			var hour = minute * 60;
			var day = hour * 24;
			var week = day * 7;
			var halfamonth = day * 15;
			var month = day * 30;
			var now = new Date().getTime();   //获取当前时间毫秒
			// console.log(now)
			var diffValue = now - dateTimeStamp;//时间差
			var result = ''
			if(diffValue < 0){
				return;
			}
			var minC = diffValue/minute;  //计算时间差的分，时，天，周，月
			var hourC = diffValue/hour;
			var dayC = diffValue/day;
			var weekC = diffValue/week;
			var monthC = diffValue/month;
			if(monthC >= 1 && monthC <= 3){
				result = " " + parseInt(monthC) + "月前"
			}else if(weekC >= 1 && weekC <= 3){
				result = " " + parseInt(weekC) + "周前"
			}else if(dayC >= 1 && dayC <= 6){
				result = " " + parseInt(dayC) + "天前"
			}else if(hourC >= 1 && hourC <= 23){
				result = " " + parseInt(hourC) + "小时前"
			}else if(minC >= 1 && minC <= 59){
				result =" " + parseInt(minC) + "分钟前"
			}else if(diffValue >= 0 && diffValue <= minute){
				result = "刚刚"
			}else {
				var datetime = new Date();
				datetime.setTime(dateTimeStamp);
				var Nyear = datetime.getFullYear();
				var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
				var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
				var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
				var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
				var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
				result = Nyear + "-" + Nmonth + "-" + Ndate
			}
			// console.log('时间差',result)
			return result;
		},
		// 兼容ios的 new Date传参, 获取时间戳; str 格式 '2020-07-15 12:00:00'
		getTimes(strdate){
			var arr = strdate.split(/[- : \/]/);
			var date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
			return date;
		}
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
